const updateTask = (state, action) => {
  if (state === undefined) {
    return {
      tasks: [],
      tasksLoading: true
    };
  }

  switch (action.type) {
    case "TASKS_REQUESTED":
      return {
        ...state.tasks,
        tasksLoading: true
      };
    case "TASKS_LOADED":
      return {
        ...state.tasks,
        tasksLoading: false,
        tasks: action.payload
      };
    case "TASKS_ERROR":
      return {
        ...state.tasks,
        tasks: [],
        tasksLoading: false,
        error: action.payload
      };

    default:
      return state.tasks;
  }
};

export default updateTask;
